var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { FieldType } from '../../../elements';
import { rules } from '../../../helpers/Validation';
import { Form } from 'components';
var DiscountReasonForm = /** @class */ (function (_super) {
    __extends(DiscountReasonForm, _super);
    function DiscountReasonForm(props) {
        var _this = _super.call(this, props) || this;
        _this.fields = [
            {
                name: 'name',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 3
            },
            {
                name: 'codeDiscount',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 3
            },
        ];
        return _this;
    }
    DiscountReasonForm.prototype.render = function () {
        var discountreason = this.props.discountreason;
        var discountReasonStore = this.props.store.discountReasonStore;
        return (React.createElement(Form, { loading: ['post@discountreasons', 'put@discountreasons', 'patch@discountreasons'], fields: this.fields, values: discountreason, store: discountReasonStore, stores: this.props.store }));
    };
    DiscountReasonForm = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id ? props.store.discountReasonStore.read(props.match.params.id).then(function (discountreason) { return ({ discountreason: discountreason }); }) : undefined
        ]; }),
        observer
    ], DiscountReasonForm);
    return DiscountReasonForm;
}(Component));
export default DiscountReasonForm;



//////////////////
// WEBPACK FOOTER
// ./src/modules/DiscountReasons/containers/DiscountReasonForm.tsx
// module id = 1590
// module chunks = 0